import React, { useEffect, useState } from "react";
import { get_almacenes_empledo } from "../../../actions/inventario";
import { SelectUi } from "../../ui/SelectUi";

export const AlmacenesEmpleadoSelect = ({ ...props }) => {
  const [almacenes, setAlmacenes] = useState([]);
  const OnLoadAlmacenes = async () => {
    const datos = await get_almacenes_empledo();
    setAlmacenes(datos);
  };
  useEffect(() => {
    OnLoadAlmacenes();
  }, []);
  return <SelectUi options={almacenes} {...props} />;
};
